<template>
  <div class="enter_innovation_wrap">
    <div class="enter_img">
      <div class="img_tit hidden-xs-only">{{ $t('hgscl.title') }}</div>
      <div class="img_tit hidden-sm-and-up">{{ $t('hgscl.title') }}</div>
    </div>

    <div class="article_content">
      <div class="article_wrap">
        <div class="article_intro">
          {{ $t('hgscl.items')[0] }}
        </div>
        
        <div class="service_list">
          <div 
            v-for="(item, index) in serviceItems" 
            :key="index" 
            class="service_item"
          >
            <div class="service_content">{{ item }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="contact_section">
      <div class="contact_wrap">
        <div class="contact_title">{{ $t('contactUs.title') }}</div>
        <div class="contact_desc">{{ $t('contactUs.desc') }}</div>
        
        <div class="contact_info">
          <div class="contact_item">
            <span class="contact_label">{{ $t('contactUs.phone') }}</span>
          </div>
          <div class="contact_item">
            <span class="contact_label">{{ $t('contactUs.phone2') }}</span>
          </div>
          <div class="contact_item">
            <span class="contact_label">{{ $t('contactUs.email') }}</span>
          </div>
          <div class="contact_item">
            <span class="contact_label">{{ $t('contactUs.address') }}</span>
          </div>
        </div>

        <div class="follow_section">
          <div class="follow_title">{{ $t('contactUs.title2') }}</div>
          <div class="follow_desc">{{ $t('contactUs.desc2') }}</div>
          <div class="qrcode_wrap">
            <img src="../../assets/img/carbon/hly-qrcode.png" alt="QR Code" class="qrcode_img" />
          </div>
        </div>
      </div>
    </div>

    <CallMe />
    <MobileCallme style="margin-top: 15rem;" />
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  components: {
    CallMe,
    MobileCallme
  },
  computed: {
    serviceItems() {
      // 获取服务项目列表（跳过第一个介绍性段落）
      const items = this.$t('hgscl.items')
      if (Array.isArray(items) && items.length > 1) {
        return items.slice(1) // 跳过第一个介绍性段落
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.enter_innovation_wrap {
  width: 100%;

  .enter_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url('../../assets/img/hly/new/关于我们/关于我们.jpg') 0 0 no-repeat;
    background-size: cover;
    background-position: center;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;

    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        text-align: center;
      }
    }
  }

  .article_content {
    width: 100%;
    margin-top: 50px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }

    .article_wrap {
      width: 60%;
      margin: 0 auto;
      @media screen and (max-width: 768px) {
        width: 90%;
      }

      .article_intro {
        font-size: 18px;
        line-height: 1.8;
        color: #333;
        margin-bottom: 40px;
        text-align: justify;
        @media screen and (max-width: 768px) {
          font-size: 16px;
          line-height: 1.6;
          margin-bottom: 30px;
        }
      }

      .service_list {
        .service_item {
          margin-bottom: 25px;
          @media screen and (max-width: 768px) {
            margin-bottom: 20px;
          }

          .service_content {
            font-size: 16px;
            line-height: 1.7;
            color: #555;
            text-align: justify;
            @media screen and (max-width: 768px) {
              font-size: 14px;
              line-height: 1.6;
            }
          }
        }
      }
    }
  }

  .contact_section {
    width: 100%;
    margin-top: 80px;
    padding: 60px 0;
    @media screen and (max-width: 768px) {
      margin-top: 50px;
      padding: 40px 0;
    }

    .contact_wrap {
      width: 60%;
      margin: 0 auto;
      @media screen and (max-width: 768px) {
        width: 90%;
      }

      .contact_title {
        font-size: 24px;
        font-weight: bold;
        color: #333;
        text-align: left;
        margin-bottom: 20px;
        @media screen and (max-width: 768px) {
          font-size: 20px;
          margin-bottom: 15px;
        }
      }

      .contact_desc {
        font-size: 16px;
        line-height: 1.6;
        color: #666;
        text-align: left;
        margin-bottom: 40px;
        @media screen and (max-width: 768px) {
          font-size: 14px;
          margin-bottom: 30px;
        }
      }

      .contact_info {
        margin-bottom: 50px;
        @media screen and (max-width: 768px) {
          margin-bottom: 40px;
        }

        .contact_item {
          margin-bottom: 15px;
          text-align: left;
          @media screen and (max-width: 768px) {
            margin-bottom: 12px;
          }

          .contact_label {
            font-size: 16px;
            color: #333;
            font-weight: 500;
            @media screen and (max-width: 768px) {
              font-size: 14px;
            }
          }
        }
      }

      .follow_section {
        text-align: left;

        .follow_title {
          font-size: 24px;
          font-weight: bold;
          color: #333;
          margin-bottom: 15px;
          @media screen and (max-width: 768px) {
            font-size: 20px;
            margin-bottom: 12px;
          }
        }

        .follow_desc {
          font-size: 14px;
          line-height: 1.6;
          color: #666;
          margin-bottom: 20px;
          @media screen and (max-width: 768px) {
            font-size: 13px;
            margin-bottom: 15px;
          }
        }

        .qrcode_wrap {
          text-align: left;
          margin-top: 20px;
          @media screen and (max-width: 768px) {
            margin-top: 15px;
          }

          .qrcode_img {
            width: 120px;
            height: 120px;
            @media screen and (max-width: 768px) {
              width: 100px;
              height: 100px;
            }
          }
        }
      }
    }
  }
}
</style>
